import * as React from "react";
import { useHistory } from "react-router";

import { Loading } from "@/components/Loading";
import { ManagementDetailCashflow } from "@/components/management/Cashflow";
import { DetailNavigation } from "@/components/management/DetailNavigation";
import { ManagementDetailView } from "@/components/management/ManagementDetailView";
import { ManagementDetailNearBy } from "@/components/management/Nearby";
import { ChangePropertyImageModal } from "@/components/management/property_actions/ChangePropertyImageModal";
import { useManagementDetailActions } from "@/components/management/property_actions/useManagementDetailActions";
import { ManagementDetailSimulation } from "@/components/management/Simulation";
import { SimulationSettings } from "@/components/management/SimulationSettings";
import { useDevice } from "@/hooks/useDevice";
import { useManagementDetailData } from "@/hooks/useManagementDetailData";
import { usePropertyViews } from "@/hooks/usePropertyViews";
import { BaseTemplate } from "@/layouts/BaseTemplate";
import { NavigationPath } from "@/utilities/enums";

import { ManagementConsiderationDetailPropertyInfo } from "./components/items/ConsiderationPropertyInfo";

export const ManagementConsiderationDetailPage = () => {
  const history = useHistory();
  const { isMobile } = useDevice();
  const imageActions = useManagementDetailActions();

  const { isLoading, error, property, cashflow_result } = useManagementDetailData();

  const { selectedView, handleViewChange } = usePropertyViews();

  if (isLoading || !property || !cashflow_result) return <Loading />;
  if (error) throw error;

  const navigation = <DetailNavigation selectedView={selectedView} onChange={handleViewChange} />;

  const renderViewContent = () => {
    switch (selectedView) {
      case "operation":
        return <ManagementDetailCashflow navigation={navigation} />;
      case "property": // 保有中と異なる表示
        return <ManagementConsiderationDetailPropertyInfo />;
      case "simulation":
        return <ManagementDetailSimulation />;
      case "nearby":
        return <ManagementDetailNearBy propertyId={property.property.id} />;
      default:
        return <ManagementDetailCashflow navigation={navigation} />;
    }
  };

  return (
    <BaseTemplate
      headerTitle={
        isMobile
          ? selectedView === "operation"
            ? "物件詳細"
            : selectedView === "property"
              ? "物件情報"
              : selectedView === "simulation"
                ? "シミュレーション"
                : "周辺の成約事例"
          : undefined
      }
      onBack={
        isMobile
          ? () =>
              selectedView === "operation" ? history.push("/management/consideration") : handleViewChange("operation")
          : undefined
      }
      navigationPath={NavigationPath.PROPERTY_MANAGEMENT_CONSIDERATION}
      isDense
      isPcV2
    >
      <ManagementDetailView
        propertyType="検討中"
        propertyHolder={property}
        monthlyBalanceSheet={cashflow_result}
        navigation={navigation}
        selectedView={selectedView}
        sidebarContent={
          selectedView === "simulation" ? (
            <SimulationSettings onCustomize={() => history.push("/management/detail/simulation?custom=1")} />
          ) : undefined
        }
        onPhotoChange={imageActions.openImageModal}
        onViewBack={() => handleViewChange("operation")}
        onBack={() => history.push("/management/consideration")}
      >
        {renderViewContent()}
      </ManagementDetailView>
      <ChangePropertyImageModal
        open={imageActions.openChangeImagePropertyModal}
        onClose={imageActions.closeImageModal}
        onClickChangeImage={(file) => imageActions.handleUpdateImage(property.property.id, file)}
      />
    </BaseTemplate>
  );
};
